import { useEffect } from 'react'
// import { useTracking } from 'react-tracking'
// import { TrackingSchemaTypes } from '../../../tracking'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/modules/rootReducer'

export const useDashboardTracking = () => {
  // const { trackEvent } = useTracking()
  const studentProfile = useSelector((state: RootState) => state.student.profile)

  const onSelectCourse = (data: { courseId: string; courseName: string }) => {
    // trackEvent({
    //   event: TrackingSchemaTypes.DashboardSelectCourse,
    //   properties: {
    //     Nome: studentProfile.name,
    //     Email: studentProfile.email,
    //     CursoID: data.courseId,
    //     CursoNome: data.courseName,
    //   },
    // })
  }

  const onStudyGoalChange = (data: { courseId: string; courseName: string; studyGoal: number }) => {
    // trackEvent({
    //   event: TrackingSchemaTypes.DashboardStudyGoalChange,
    //   properties: {
    //     Nome: studentProfile.name,
    //     Email: studentProfile.email,
    //     CursoID: data.courseId,
    //     CursoNome: data.courseName,
    //     Meta: data.studyGoal,
    //   },
    // })
  }

  useEffect(() => {
    if (!studentProfile) return

    // trackEvent({
    //   event: TrackingSchemaTypes.DashboardAccess,
    //   properties: {
    //     Nome: studentProfile.name,
    //     Email: studentProfile.email,
    //   },
    // })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentProfile])

  return { onSelectCourse, onStudyGoalChange }
}

export type TTrackingEvents = ReturnType<typeof useDashboardTracking>
